import { useQuery } from '@apollo/client'
import { useLocation } from 'react-router-dom'
import errorCardModalPayload from '../../../components/error_card/errorCardModalPayload'
import Loader, { LoaderType } from '../../../components/loader'
import { Page } from '../../../components/Page'
import {
  useActions,
  useErrorModal,
  useFooter,
  useTypedSelector,
} from '../../../hooks'
import { BlogEvent } from '../../../types'
import { getSlug } from '../../../utils'
import { FeaturedEventProvider } from '../context'
import { GET_EVENT } from '../queries/events'
import EventsDetail from './events_detail/EventsDetail'
import FeaturedEvent from './FeaturedEvent'
import { useCallback, useEffect } from 'react'

const EventPageHandler: React.VFC = () => {
  const { pathname } = useLocation()
  const { openModal } = useActions()
  const modal = useTypedSelector(({ modal }) => modal)
  const path = pathname
  const slug = getSlug(path)
  const { data, error, loading } = useQuery(GET_EVENT, { variables: { slug } })
  const setFooter = useFooter((s) => s.setConfig)

  useErrorModal(error)

  const event = (data?.eventCollection?.items[0] as BlogEvent) || null

  const handleSetFooter = useCallback(() => {
    setFooter({ hidden: event?.featured === 'Yes' })
  }, [event?.featured, setFooter])

  useEffect(() => {
    handleSetFooter()
  }, [handleSetFooter])

  if (loading) return <Loader type={LoaderType.fullscreen} />

  if (!event) {
    if (!modal?.isOpen) {
      const { content, modalType } = errorCardModalPayload()
      openModal(content, modalType)
    }
    return <div />
  }

  let content = <EventsDetail event={event} />

  if (event.featured === 'Yes') {
    content = (
      <FeaturedEventProvider event={event}>
        <FeaturedEvent />
      </FeaturedEventProvider>
    )
  }

  return (
    <Page
      head={{
        title: event.title,
        image: event.listImage?.url,
        seoTitle: event.seoTitle,
        seoDescription: event.seoDescription,
        canonical: true,
      }}
    >
      {content}
    </Page>
  )
}

export default EventPageHandler
